import React from 'react'
import Armchairs from '../components/Armchairs'
import Shopbody from '../components/Shopbody'
import Footer from '../components/Footer'

const Armchairsp = () => {
  return (
    <>
        <Armchairs/>
        <div className='space2'></div>
        <Shopbody/>
        <div className='space'></div>
        <Footer/>
    </>
  )
}

export default Armchairsp